import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faExclamationTriangle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import makeStyles from "@mui/styles/makeStyles";

import Typography from "@mui/material/Typography";

interface Props {
  className?: string;
  invalidMessage: string;
  validationType?: "success" | "warning" | "error" | "info";
  showIcon?: boolean;
}

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "3px",
  },
  icon: {
    fontSize: "1em",
    marginRight: theme.spacing(1),
  },
  success: {
    color: theme.palette.success.main,
  },
  warning: {
    color: theme.palette.warning.main,
  },
  error: {
    color: theme.palette.error.main,
  },
  info: {
    color: theme.palette.info.main,
  },
}));

export function ValidationMessage(props: Props) {
  const classes = useStyles();

  const [icon, setIcon] = useState(faCheckCircle);

  useEffect(() => {
    switch (props.validationType) {
      case "success":
        setIcon(faCheckCircle);
        break;
      case "warning":
        setIcon(faExclamationTriangle);
        break;
      case "error":
        setIcon(faExclamationTriangle);
        break;
      case "info":
        setIcon(faInfoCircle);
        break;
    }
  }, [props.validationType]);

  return (
    <div className={clsx(classes.root, props.className)}>
      <Typography
        variant="caption"
        gutterBottom
        className={clsx({
          [classes.error]: props.validationType === "error",
        })}
      >
        {props.showIcon && (
          <FontAwesomeIcon
            icon={icon}
            className={clsx(classes.icon, {
              [classes.success]: props.validationType === "success",
              [classes.warning]: props.validationType === "warning",
              [classes.error]: props.validationType === "error",
              [classes.info]: props.validationType === "info",
            })}
          />
        )}
        {props.invalidMessage}
      </Typography>
    </div>
  );
}
